import axios from 'axios';

const API = '/api/ai';

/** Глобальный in-flight запрос — переживает remount React при смене маршрута */
let inFlight = null;

export function getInFlightRequest() {
  return inFlight;
}

export function clearInFlightRequest() {
  inFlight = null;
}

export async function postChat(sessionId, message, files = []) {
  let promise;
  if (files?.length) {
    const form = new FormData();
    if (sessionId) form.append('sessionId', sessionId);
    form.append('message', message || '');
    files.forEach(f => form.append('files', f));
    promise = axios.post(`${API}/chat`, form);
  } else {
    promise = axios.post(`${API}/chat`, { sessionId, message });
  }
  inFlight = { promise, sessionId, message, startedAt: Date.now() };
  try {
    return await promise;
  } finally {
    inFlight = null;
  }
}

export async function fetchSession(sessionId) {
  const res = await axios.get(`${API}/session/${sessionId}`);
  return res.data;
}
